<script lang="ts">
    import { modals, Modals } from "@wa-modals";
</script>

<Modals>
    <!--
        Backdrop click-to-dismiss is a pointer-only convenience: a full-screen backdrop must not be a
        keyboard tab stop, and keyboard users close the dialog with Escape (handled by the modal content,
        which also traps focus). The a11y warnings are therefore intentionally suppressed here.
    -->
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    {#snippet backdrop()}
        <div class="backdrop" onclick={() => modals.close()} aria-hidden="true"></div>
    {/snippet}
</Modals>

<style>
    .backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 2000;
        pointer-events: auto;
    }
</style>
